import React from "react";
import './Footer.css';
import { Container, Button, Image, Checkbox, Stack } from '@chakra-ui/react'

function Footer() {

    return(
       <div className="footer_parent_box">
        <div className="footer_top_section">
            <div className="footer_top_section_first">
                  <h3>NEW TO YOOX</h3>
                  <hr></hr>
                  <p> Shopping guide </p>
                  <p> iPhone/iPad/Android </p>
                  <p> Browse all Designers </p>
                  <p> Browse all Categories </p>
            </div>
            <div className="footer_top_section_second">
                  <h3>HELP</h3>
                  <hr></hr>
                  <p> Shipping times & costs </p>
                  <p> Payments and web security </p>
                  <p> Product quality </p>
                  <p> Track your order </p>
                  <p> Returns & refunds </p>
                  <p> FAQs </p>
                  <p> Size Guide </p>
            </div>
            <div className="footer_top_section_third">
                  <div><img src="https://icones.pro/wp-content/uploads/2021/02/icone-de-courrier-electronique-gris.png" alt="logo" /></div>
                  <h2> YOOX NEWS </h2>
                  <div className="pera">
                        <p>Sign up for the newsletter
                        and discover the latest arrivals and promotions
                        </p>
                  </div>
                  <div className="input" >
                        <input  placeholder="INSERT YOUR E-MAIL ADDRESS" />
                  </div>
                  <div style={{display:"flex", width:'80%', margin:"auto", marginTop:"5%", justifyContent:"space-between" }}>
                     <input type="radio" name="gender" value="women" colorScheme='gray' /><label>Women</label>
                     <input type="radio" name="gender" value="men" colorScheme='gray' /><label>Men</label>
                  </div>
                  <div style={{width:'80%',marginTop:"0px"}}>
                    <Checkbox defaultUnchecked value='naruto'> <i style={{color:"gray",padding:"0px", fontSize:'10px'}}> 	I agree to the use of my personal data in order to be updated on new arrivals </i> 
                    </Checkbox>
                  </div>
                  <Button bg='#333' color='white' >Submit</Button>
                  
            </div>
            <div className="footer_top_section_fourth">
                  <h3> MYOOX </h3>
                  <hr></hr>
                  <p> Login </p>
                  <p> My Orders </p>
                  <p> My Details </p>
                  <p> Dream Box </p>
                  <p> Première </p>
            </div>
            <div className="footer_top_section_fifth">
                  <h3> ABOUT US </h3>
                  <hr></hr>
                  <p> Company Info </p>
                  <p> Press </p>
                  <p> My Details </p>
                  <p> Affiliation </p>
                  <p> Careers </p>
            </div>
        </div>

        <Container maxW='100%' bg='#333' mb='0px' color='#fff' height='130px'>
            <p style={{fontSize:'10px', paddingTop:'5%'}}> POWERED BY YOOX NET-A-PORTER GROUP - COPYRIGHT © 2000-2022 YOOX NET-A-PORTER GROUP S.P.A. - ALL RIGHTS RESERVED - SIAE LICENCE # 401/I/526</p>
            <p style={{fontSize:'10px', paddingTop:'0%'}}>LEGAL AREA / PRIVACY POLICY</p>
        </Container>
       </div>
    )
}

export default Footer;